/**
 * API configuration constants
 * Centralizes all API URL configuration to ensure consistency across the application
 */

// Base API URL from environment variable
// Trailing slash stripped so appending "/api/v1" below never produces "//api".
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

// API version path
export const API_VERSION = 'v1';

// Complete API base URL with version
// Check if API_BASE_URL already includes /api/v1 to avoid duplication
export const API_URL = API_BASE_URL.includes('/api/v1')
  ? API_BASE_URL
  : `${API_BASE_URL}/api/${API_VERSION}`;

export const WEBSOCKET_AUTH_TOKEN_PARAM =
  import.meta.env.VITE_WS_AUTH_TOKEN_PARAM || 'token';

const defaultWebSocketBaseUrl = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
};

export const WEBSOCKET_BASE_URL =
  import.meta.env.VITE_WS_BASE_URL || defaultWebSocketBaseUrl();
export const WEBSOCKET_NOTIFICATIONS_PATH =
  import.meta.env.VITE_WS_NOTIFICATIONS_PATH || '/ws/events/';

export const buildWebSocketUrl = (
  path: string,
  queryParams: Record<string, string> = {}
): string => {
  const cleanBase = WEBSOCKET_BASE_URL.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const url = `${cleanBase}${cleanPath}`;

  const searchParams = new URLSearchParams(queryParams);
  return searchParams.toString() ? `${url}?${searchParams.toString()}` : url;
};

// Function to build API endpoint URLs
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};